export const serveFromBunny = (url) => {
  return url &&
    process.env.GATSBY_BUNNY_PROXY_URL &&
    process.env.GATSBY_BUNNY_ORIGIN_URL
    ? url.replace(
        process.env.GATSBY_BUNNY_ORIGIN_URL,
        process.env.GATSBY_BUNNY_PROXY_URL
      )
    : null
}
export const serveImageFromBunny = (url) => {
  const processedUrl =
    url &&
    process.env.GATSBY_BUNNY_PROXY_URL &&
    process.env.GATSBY_BUNNY_ORIGIN_URL
      ? url.replace(
          process.env.GATSBY_BUNNY_ORIGIN_URL,
          process.env.GATSBY_BUNNY_PROXY_URL
        )
      : null
  return [processedUrl, processedUrl?.includes("?") ? "&" : "?"]
}
